import { api, handleApiCall, ApiResult } from './api';
import {
  LocationDto,
  StorageDto,
  ShelfDto,
  ProductLoteLocationDto,
  ProductLoteShelfDto,
  CreateLocationRequest,
  UpdateLocationRequest,
  CreateStorageRequest,
  CreateShelfRequest,
  InventoryCheckoutRequest,
  InventoryCheckoutDto,
  InventoryCheckinRequest,
  InventoryCheckinDto
} from '../types/location';

// Re-export types for components that need them
export type { 
  LocationDto, 
  StorageDto, 
  ShelfDto, 
  ProductLoteLocationDto, 
  ProductLoteShelfDto,
  InventoryCheckoutDto,
  InventoryCheckinDto
};

// Legacy interface names for backward compatibility
export interface EditLocationRequest extends UpdateLocationRequest {}
export interface AddStorageRequest extends CreateStorageRequest {}
export interface AddShelfRequest extends CreateShelfRequest {}
export interface CheckoutInventoryRequest extends InventoryCheckoutRequest {}
export interface CheckinInventoryRequest extends InventoryCheckinRequest {}

// Location API functions
export async function getLocations(): Promise<LocationDto[]> {
  return handleApiCall(() => api.get<ApiResult<LocationDto[]>>('/api/location'));
}

export async function addLocation(name: string, description?: string): Promise<LocationDto> {
  return handleApiCall(() => api.post<ApiResult<LocationDto>>('/api/location', { name, description }));
}

export async function editLocation(publicId: string, request: EditLocationRequest): Promise<LocationDto> {
  return handleApiCall(() => api.put<ApiResult<LocationDto>>(`/api/location/${publicId}`, request));
}

export async function deleteLocation(publicId: string): Promise<void> {
  return handleApiCall(() => api.delete<ApiResult<void>>(`/api/location/${publicId}`));
}

export async function checkoutInventory(request: CheckoutInventoryRequest): Promise<InventoryCheckoutDto> {
  return handleApiCall(() => api.post<ApiResult<InventoryCheckoutDto>>('/api/location/checkout', request));
}

export async function checkinInventory(request: CheckinInventoryRequest): Promise<InventoryCheckinDto> {
  return handleApiCall(() => api.post<ApiResult<InventoryCheckinDto>>('/api/location/checkin', request));
}

// Storage API functions
export async function addStorage(request: AddStorageRequest): Promise<StorageDto> {
  return handleApiCall(() => api.post<ApiResult<StorageDto>>('/api/location/storage', request));
}

// Shelf API functions
export async function addShelf(request: AddShelfRequest): Promise<ShelfDto> {
  return handleApiCall(() => api.post<ApiResult<ShelfDto>>('/api/location/shelf', request));
}
